import { render, staticRenderFns } from "./CenterList.vue?vue&type=template&id=22617333&scoped=true&"
import script from "./CenterList.vue?vue&type=script&lang=ts&"
export * from "./CenterList.vue?vue&type=script&lang=ts&"
import style0 from "./CenterList.vue?vue&type=style&index=0&id=22617333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22617333",
  null
  
)

component.options.__file = "CenterList.vue"
export default component.exports